export default "__VITE_ASSET__ClFViJsU__"